import type { RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { AccountSecurityPage } from './AccountSecurityPage';
import { DeviceCertificatesPage } from './DeviceCertificatesPage';
import { IpRulesPage } from './IpRulesPage';

/**
 * セキュリティ機能の画面（パスは `/years/:year` からの相対）。
 *   account/security             2段階認証の設定（本人。全ロール）
 *   admin/ip-rules               S-97 IP アドレス制限（基金）
 *   admin/device-certificates    S-98 端末証明書（基金）
 * ログイン時の確認コード入力・認証アプリ登録（/login/mfa, /login/mfa-setup）は src/routes.tsx の公開ルート。
 */
export const routes: RouteObject[] = [
  { path: 'account/security', handle: { crumb: '2段階認証の設定' } satisfies RouteHandle, element: <AccountSecurityPage /> },
  {
    path: 'admin/ip-rules',
    handle: { crumb: 'IPアドレス制限' } satisfies RouteHandle,
    element: (
      <RequireAuth roles={['基金']}>
        <IpRulesPage />
      </RequireAuth>
    ),
  },
  {
    path: 'admin/device-certificates',
    handle: { crumb: '端末証明書' } satisfies RouteHandle,
    element: (
      <RequireAuth roles={['基金']}>
        <DeviceCertificatesPage />
      </RequireAuth>
    ),
  },
];
